module.exports = __webpack_public_path__ + "static/media/2c_background.e6437360.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/2c_background.png
// module id = 2492
// module chunks = 0